interface IconProps {
  fill?: string;
}

const Guides = ({ fill }: IconProps) => {
  return (
    <svg
      width="25"
      height="21"
      viewBox="0 0 25 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.88375 18.9538C5.86921 12.3751 3.89943 6.89909 2.2044 3.66021C1.67684 2.65215 2.32784 1.32074 3.46314 1.24597L19.1263 0.214495C19.4585 0.192618 19.7919 0.282551 20.0481 0.49515C24.687 4.34438 24.2182 13.7751 23.9616 18.9358L23.9548 19.073C23.9163 19.8482 23.2772 20.4602 22.5011 20.4602H7.35843C6.53765 20.4602 5.88557 19.7746 5.88375 18.9538Z"
        fill={fill}
      />
      <rect
        x="5.9248"
        y="5.29688"
        width="12.3079"
        height="1.23079"
        rx="0.615393"
        fill="#FAFAFA"
      />
      <rect
        x="7.15625"
        y="10.2173"
        width="9.84629"
        height="1.23079"
        rx="0.615393"
        fill="#FAFAFA"
      />
      <rect
        x="7.15625"
        y="15.1416"
        width="6.15393"
        height="1.23079"
        rx="0.615393"
        fill="#FAFAFA"
      />
    </svg>
  );
};

export { Guides };
